import React from "react";
import { Input } from "semantic-ui-react";

const UserInput = props => <Input autoComplete={props.type === "password" ? "new-password" : "off"} {...props} />;

export default UserInput;
